import { Hint } from '@synoptic/ui-kit/hint/hint.tsx';
import { InfoCircleIcon } from '@synoptic/ui-kit/icons/react/info-circle.tsx';
import { CustomTargetsDataFragmentFragment } from '@/__generated__/graphql.ts';
import { Stepper } from '@/components/stepper/stepper';
import {
  paymentOptionDescription,
  paymentOptionsTitle,
} from '@/components/streams/payment-options/payment-options.css.ts';
import {
  discountSubInfo,
  discountThenPrice,
  priceContainer,
  priceMain,
  priceStepperSection,
  priceSubInfo,
} from '@/components/streams/payment-options/price-stepper-section.css.ts';
import { StepperPrice } from '@/components/streams/payment-options/price-stepper-utils.ts';
import { convertCentsToDollars } from '@/utils/convert-cents-to-dollars.ts';
import { formatIntervalShort } from '@/utils/paid-data.ts';

export const PriceStepperSection = ({
  customTargets,
  selectedPrice,
  discountAmountCents,
  targetsCount,
  setTargetsCount,
}: {
  customTargets: NonNullable<CustomTargetsDataFragmentFragment>;
  selectedPrice: StepperPrice;
  discountAmountCents?: number;
  targetsCount: number;
  setTargetsCount: (count: number) => void;
}) => {
  const steps = targetsCount / customTargets.stepSize;
  const totalPrice = Math.round(selectedPrice.amount * steps);
  const intervalLabel = formatIntervalShort(
    selectedPrice.interval,
    selectedPrice.intervalCount,
  );

  return (
    <div className={priceStepperSection}>
      <div className={paymentOptionsTitle}>
        How many targets do you want to monitor?
        <Hint
          description={
            'Choose any number within the author’s set range. ' +
            'For example, if the range is 5 to 20 with steps of 5, ' +
            'you can select 5, 10, 15, or 20.'
          }
        >
          <InfoCircleIcon width={16} height={16} />
        </Hint>
      </div>

      <div className={paymentOptionDescription}>
        You can select up to {customTargets.maxTargets} targets. The price
        depends on the selected amount.
      </div>

      <Stepper
        count={targetsCount}
        setCount={setTargetsCount}
        step={customTargets.stepSize}
        minCount={customTargets.minTargets}
        maxCount={customTargets.maxTargets}
        commitOnType={false}
      />

      <div className={priceContainer}>
        {discountAmountCents != null ? (
          <>
            <span className={priceMain}>
              US$
              {convertCentsToDollars(
                Math.max(0, totalPrice - discountAmountCents),
              )}
            </span>
            <span className={discountSubInfo}>
              <span>for first {intervalLabel}</span>
              <span className={discountThenPrice}>
                then US${convertCentsToDollars(totalPrice)}/{intervalLabel}
              </span>
            </span>
          </>
        ) : (
          <>
            <span className={priceMain}>
              US${convertCentsToDollars(totalPrice)}
            </span>
            <span className={priceSubInfo}>
              per <br /> {intervalLabel}
            </span>
          </>
        )}
      </div>
    </div>
  );
};
